$(document).ready(function () {
  $(document).on('click', '.clients-client-task-bin-component .checkboxes__option', function () {
    // Update checkbox values back to the server
    const thisComponent = $(this).closest('.component');
    const clientTaskId = $(this).attr('attr');
    const value = $(this).hasClass('checked');
    updateClientTaskStatus(clientTaskId, value, thisComponent);
  });

  $(document).on('click', '.clients-client-task-bin-component .remove-checkbox-option-js', function () {

    const checkbox = $(this).closest('.checkbox-option-container-js')
    const id = checkbox.attr('id')
    const task_summaries = $('.clients-client-task-bin-component')

    $.ajax({
      url: `/components/clients/client_task_bin/delete/${id}`,
      method: 'delete'
    }).done(function(data) {
      checkbox.remove();

      task_summaries.each(function () {
        reloadComponent($(this));
      });
    }).fail(function(response) {
      alert(`There was an issue removing this data. Let us know if this issue persists.`)
    });
  });


  // Update the server with the new checkbox value
  // Takes in the client task id and a boolean value representing the checkbox state
  function updateClientTaskStatus(id, value, thisComponent) {
    $.post('/components/clients/client_task_bin', {id: id, value: value}).done(function (data) {
      // Tell all other similar client task bin components to reload
      const completableId = thisComponent.attr('client_task_completable_id');
      const completableType = thisComponent.attr('client_task_completable_type');
      const otherComponents = $(`.clients-client-task-bin-component[client_task_completable_id=${completableId}][client_task_completable_type=${completableType}]`);
      otherComponents.each(function () {
        if ($(this).is(thisComponent)) return;

        reloadComponent($(this));
      });
    });
  }
});
